import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';

import LoadingComponent from '../../components/common/LoadingComponent';
import { Text } from '../../components/common/Text';
import { FlyInTransition } from '../../components/transitions/transitions';
import {
  getAllWorkouts,
  resetHealthGoals,
} from '../../services/health-content';
import Modal from '../common/Modal';
import Player from './FitnessPlayer';
import MyFitness from './MyFitness';
import { updateFitnessActiveTab } from '../../actions';
import Header from '../../components/common/Header';
import StartWorkoutPlanBanner from '../../components/health-content/StartWorkoutPlanBanner';
import ResetWorkoutButton from '../../components/common/ResetWorkoutButton';
import arrowBack from '../../images/arrow_back.svg';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  background: white;
`;

const BodyContainer = styled.div`
  flex: 1;
  flex-shrink: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // padding: 16px;
`;

const SectionHeader = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #0f0b28;
  margin-left: 4px;
  text-transform: capitalize;
`;

const CardContent = styled.div`
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
  width: 180px;
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 24px 16px;
`;

const CardTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #0f0b28;
`;

const CardDescription = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #585969;
  margin-top: 2px;
`;

const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.5);
`;

const AngleRight = styled(FaChevronRight)`
  color: #413958;
  width: 8px;
  height: 8px;
`;

class FitnessHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      allWorkouts: [],
      showPlayerModal: false,
      selectedAlbum: null,
      activeTab: this.props?.fitnessActiveTab,
      program: false,
      showFitnessProgram: false,
    };
  }

  componentDidMount() {
    this.getAllWorkouts();
    if (
      typeof window.Android !== 'undefined' &&
      window.Android &&
      window.Android.podcastPage
    ) {
      return window.Android.podcastPage();
    }
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'podcastPage',
        })
      );
    }
  }

  getAllWorkouts() {
    getAllWorkouts(this.props.authToken)
      .then((res) => {
        this.setState({
          allWorkouts: res.cards,
          program: res.program,
          showFitnessProgram: res.showFitnessProgram,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  onAlbumClick = (album) => {
    if (album.showAudioPlayer) {
      this.setState({ selectedAlbum: album, showPlayerModal: true });
    } else {
      //it is a album container
      this.props.history.push('/health-content/sub-fitness', {
        albumId: album.albumId,
      });
    }
  };

  hideModal = () => {
    this.setState({ showPlayerModal: false });
  };

  closeView = () => {
    if (this.props.magicBasedLogin) {
      if (typeof window.Android !== 'undefined') {
        window.Android.closeView();
        window.Android.closeView(true);
      } else if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
        window.webkit.messageHandlers.visitIosView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else {
        this.props.history.goBack();
      }
    } else {
      this.props.history.goBack();
    }
  };
  handleReset = async () => {
    try {
      this.setState({ loading: true });
      await resetHealthGoals(this.props.authToken);
      this.getAllWorkouts();
      this.setState({ program: false, activeTab: 'my-fitness' });
      this.props.dispatch(updateFitnessActiveTab('my-fitness'));
    } catch (err) {
      console.error('Error resetting health goals:', err);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      allWorkouts,
      showPlayerModal,
      selectedAlbum,
      loading,
      showFitnessProgram,
      program,
    } = this.state;
    const renderWorkoutCards = (cards) => {
      return cards.map((card) => {
        const albums = card.albums;
        return (
          <div key={card.title}>
            <div className="flex justify-between mt-20px px-16px">
              <div className="flex">
                <img
                  src={card.sectionIcon}
                  alt="section-icon"
                  width={'16px'}
                  style={{ height: '16px' }}
                />
                <SectionHeader>{card.title}</SectionHeader>
              </div>
              {card.seeAll && (
                <div
                  className="flex items-center cursor-pointer"
                  onClick={() =>
                    this.props.history.push(
                      `/health-content/fitness-home/${card.type}`,
                      {
                        card,
                      }
                    )
                  }
                >
                  <p className="text-body-s font-semibold text-purpleText">
                    See all
                  </p>
                  <div className="p-5 bg-primary-shades1 rounded-full ml-8px">
                    <AngleRight />
                  </div>
                </div>
              )}
            </div>
            {albums && albums.length > 0 && (
              <div className="flex overflow-x-auto justify-start mt-16px px-16px">
                {albums.map((album) => {
                  return (
                    <button
                      onClick={() => this.onAlbumClick(album)}
                      className="text-left mr-16px relative"
                      key={album.albumId}
                    >
                      {album.sessionCount && (
                        <p
                          className="absolute px-8px py-2px text-card-body font-semibold text-textbox rounded-12 top-12px left-12px"
                          style={{
                            background: '#0F0B2833',
                          }}
                        >
                          {album.sessionCount} Videos
                        </p>
                      )}
                      <img
                        src={album.imageUrl}
                        style={{
                          width: '185px',
                          height: '185px',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                        }}
                      />
                      <CardContent>
                        <CardTitle>{album.albumTitle}</CardTitle>
                        <CardDescription>By {album.coachName}</CardDescription>
                      </CardContent>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      });
    };
    const handleHeaderToggle = (activeTab) => {
      this.setState({ activeTab });
      this.props.dispatch(updateFitnessActiveTab(activeTab));
    };
    const HeaderTab = () => {
      return (
        <div className="w-full px-16px py-2 border-b border-txtsecondary-shades7">
          <div className="bg-txtlight-shades4 flex justify-between rounded-lg p-1 h-10">
            <button
              className={`hover:opacity-75 text-body-s font-semibold rounded-lg w-full h-full ${
                this.state.activeTab === 'fitness-library' && 'bg-textbox'
              }`}
              onClick={() => handleHeaderToggle('fitness-library')}
            >
              Library
            </button>
            <button
              className={`hover:opacity-75 text-body-s font-semibold rounded-lg w-full ${
                this.state.activeTab === 'my-fitness' && 'bg-textbox'
              }`}
              onClick={() => handleHeaderToggle('my-fitness')}
            >
              My Program
            </button>
          </div>
        </div>
      );
    };

    console.log('program', program);
    return (
      <OuterContainer>
        <Header
          title="Fitness"
          onTap={() => this.closeView()}
          // style={{ padding: '0 16px' }}
        >
          {program && (
            <ResetWorkoutButton
              setLoading={(loading) => this.setState({ loading })}
            />
          )}
        </Header>
        <HeaderTab />
        <BodyContainer>
          {loading ? (
            <LoadingComponent />
          ) : (
            <>
              {this.state.activeTab === 'fitness-library' ? (
                <div>
                  {!program && showFitnessProgram && (
                    <StartWorkoutPlanBanner
                      onClick={() => handleHeaderToggle('my-fitness')}
                    />
                  )}
                  {renderWorkoutCards(allWorkouts)}
                </div>
              ) : (
                <MyFitness onboarded={!this.state.program} />
              )}
              {/* <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(personalGrowthAlbums)}
          </div>
          <div style={{ marginTop: '25px' }}>
            {renderPodcastCards(workAlbums)}
          </div> */}
            </>
          )}
        </BodyContainer>
        {showPlayerModal && (
          <Modal>
            <ModalContainer onClick={this.hideModal}>
              <FlyInTransition
                in={showPlayerModal}
                mountOnEnter
                unmountOnExit
                appear
              >
                <Player
                  album={selectedAlbum}
                  authToken={this.props.authToken}
                  hideModal={this.hideModal}
                />
              </FlyInTransition>
            </ModalContainer>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  fitnessActiveTab: state.app.fitnessActiveTab,
  magicBasedLogin: state.app.magicBasedLogin,
});

export default connect(mapStateToProps)(FitnessHome);
